import { render, staticRenderFns } from "./DetailSellView.vue?vue&type=template&id=0f35a7e2&"
import script from "./DetailSellView.vue?vue&type=script&lang=js&"
export * from "./DetailSellView.vue?vue&type=script&lang=js&"
import style0 from "./DetailSellView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports